$( document ).ready(function() {

  
  
  //Sticky header
  
  $(window).scroll(function() {
    
    var sliderHeight = $(".index__slider").height() - $(".header").height();
    
    if ($(this).scrollTop() > 1 && !$("body").hasClass("template-index")) {  
      $('.header').addClass("sticky");
    } else if ($(this).scrollTop() > sliderHeight && $("body").hasClass("template-index")) { 
      $('.header').addClass("sticky");
    } else {
      $('.header').removeClass("sticky");
    }
    
  });
  
  
  $('.index-module').has('.parallax').addClass('parallax-wrapper');
  $('.collection__links-list').find('.collection__link-item.Limited-Edition').appendTo('.collection__links-list');
  
  //Slick slider
  
//   $('.index-project-slider .slick-slider').slick({
//     slidesToShow: 4,
//     slidesToScroll: 4,
//     prevArrow: '<span class="slick-prev"><i class="icon-nav-left"></i></span>',
//     nextArrow: '<span class="slick-next"><i class="icon-nav-right"></i></span>',
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           infinite: true
//         }
//       },
//       {
//         breakpoint: 767,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2
//         }
//       }
//       // You can unslick at a given breakpoint now by adding:
//       // settings: "unslick"
//       // instead of a settings object
//     ]
//   });

  var filtered = false;

  $('.js-filter').on('click', function(){
    if (filtered === false) {
      $('.filtering').slick('slickFilter',':even');
      $(this).text('Unfilter Slides');
      filtered = true;
    } else {
      $('.filtering').slick('slickUnfilter');
      $(this).text('Filter Slides');
      filtered = false;
    }
  });
  
  
  //Product info height
//   $(window).on('load resize', function(){
//     if (window.matchMedia('(min-width: 960px)').matches) {
//       if($(".product__slideshow").height() > $(".product__info").height()){
//         var pInfoHeight = $(".product__slideshow").height();
//         $('.product__info').css("height", pInfoHeight);
//       }
//     }
//   });
  
  
  
  $(window).on('load resize', function(){ 
  
    //Homepage Slider

    function hpSliderResize(){


      var windowRatio = ($( window ).height()) / ($( window ).width());
      var imgRatio = ($('.template-index .index__slider .slick-slide img').height()) / ($('.template-index .index__slider .slick-slide img').width()); 

      var imgSlideWidth = $( window ).width();
      var imgSlideHeight = imgSlideWidth * imgRatio;


      if( windowRatio < imgRatio ){

        $('.template-index .index__slider .slick-slide img').height(imgSlideHeight).width(imgSlideWidth);
        $('.template-index .index__slider .slick-slide img').css({

          'position' : 'absolute',
          'top' : ($( window ).height() - imgSlideHeight) / 2,
          'left' : '0' 

        });
        $('.template-index .index__slider .slick-slide a').css({

          'position' : 'relative',
          'overflow' : 'hidden',
          'display' : 'block',
          'height' : $( window ).height()

        });
        
      } else {
        
        $('.template-index .index__slider .slick-slide img').css({

          'height' : 'auto',
          'width' : '100%',
          'position' : 'inherit',
          'top' : '0',
          'left' : '0' 

        });
        $('.template-index .index__slider .slick-slide a').css({

          'position' : 'relative',
          'overflow' : 'hidden',
          'display' : 'block',
          'height' : 'auto'

        });
      }
    }
  
//     hpSliderResize();

//     $( window ).resize(function() {
//       hpSliderResize();
//     });
    
  });
  
  
  
  // Add active style to top menu links if it contains...
  
  if(window.location.href.indexOf("/collections/") > -1) {
     $('.Collection a').addClass('active');
  }
  if(window.location.href.indexOf("pages/showroom") > -1) {
     $('.Showroom a').addClass('active');
  }
  if(window.location.href.indexOf("pages/campaign") > -1) {
     $('.Campaign a').addClass('active');
  }

  
  $(window).on('load resize', function(){
  	var menuWidth = ($('.navigation-horizontal__list > .navigation-horizontal__list-item:eq(0)').outerWidth() + $('.navigation-horizontal__list > .navigation-horizontal__list-item:eq(1)').outerWidth() + 1);
    $('.navigation-horizontal__dropdown').css({'width':menuWidth}); 
  });
  
  
  
  if($('.product__tabs').length){
    
    if(!$('.product__tabs').has('li').length){
      console.log('tabs');
    	$('.product__tabs').css('border-bottom', 'none');
    }
  }
  
  
  if(window.location.href === "https://elemento-design.com/collections/projects"){
    $('.navigation-horizontal__list-item--expandable a.active').removeClass('active');
  }
  
  
  $(document).on("click", ".navigation-sidebar__item:nth-child(6)", function(){
  	$('[data-action="close-navigation-sidebar"]').click();
  });
  
});

$('.navigation-horizontal__dropdown-item--expandable[data-level="2"] > .navigation-horizontal__dropdown-link').on('click', function() {
  var element = $(this),
      item = element.closest('.navigation-horizontal__dropdown-item');

  element.closest('[data-level="2"]').addClass('current-element');
  item.toggleClass('navigation-horizontal__dropdown-item--active');
  item.siblings().removeClass('navigation-horizontal__dropdown-item--active');

  $('[data-level="2"]:not(".current-element")').removeClass('current-active');
  
  element.closest('[data-level="2"]').toggleClass('current-active').removeClass('current-element');
  
  return false;
});

